import type { Assign } from '@ark-ui/react'
import { Field as ArkField, useField } from '@ark-ui/react/field'
import { forwardRef, useState } from 'react'
import { useEnhancedChildren } from '~/hooks/use-enhanced-children'
import { cn } from '~/utils/cn'
import type { InputHTMLAttributes } from 'react'

export type InputTextSharedProps = {
  /**
   * Se o input tem um error.
   */
  hasError?: boolean

  /**
   * Variante do tamanho do input
   */
  size?: 'md' | 'ml' | 'lg' | 'xl'

  /**
   * Valor do input
   */
  value?: string
}

export type InputTextRootProps = Assign<
  React.ComponentProps<typeof ArkField.Root>,
  InputTextSharedProps
> &
  Pick<
    InputHTMLAttributes<HTMLInputElement>,
    'disabled' | 'readOnly' | 'children'
  >

export const InputTextRoot = forwardRef<HTMLDivElement, InputTextRootProps>(
  (
    { children, size = 'ml', value, disabled, readOnly, hasError, ...props },
    ref
  ) => {
    const [isActive, setActive] = useState(false)

    const field = useField({
      disabled,
      invalid: hasError,
    })

    const enhancedChildrenWithInjectProps = useEnhancedChildren(children, {
      targets: [
        'InputTextLabel',
        'InputTextActions',
        'InputTextHelperText',
      ],
      props: {
        size,
        readOnly,
        hasError,
        value,
      },
    })

    return (
      <ArkField.RootProvider
        {...props}
        ref={ref}
        className="flex w-full flex-col gap-halfpulse"
        value={field}
      >
        {enhancedChildrenWithInjectProps}
      </ArkField.RootProvider>
    )
  }
)

InputTextRoot.displayName = 'InputTextRoot'
